import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "scg" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "scg__error",
  role: "alert"
}
const _hoisted_4 = ["disabled"]

import { onMounted, ref } from 'vue'
import { isContractAuthError, unlockServiceContract } from '@/api/serviceContract'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContractGate',
  emits: ["unlocked"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const password = ref('')
const error = ref('')
const busy = ref(false)
const inputEl = ref<HTMLInputElement | null>(null)

onMounted(() => {
  inputEl.value?.focus()
})

async function onSubmit() {
  if (busy.value) return
  error.value = ''
  busy.value = true
  try {
    await unlockServiceContract(password.value.trim())
    emit('unlocked')
  } catch (e) {
    error.value = isContractAuthError(e) || e instanceof Error
      ? (e instanceof Error ? e.message : '비밀번호가 맞지 않습니다.')
      : '비밀번호가 맞지 않습니다.'
  } finally {
    busy.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", {
      class: "scg__card",
      onSubmit: _withModifiers(onSubmit, ["prevent"])
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "scg__eyebrow" }, "HAMWOORI / SERVICE AGREEMENT", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "scg__title" }, "계약서 보관함", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "scg__lead" }, "비밀번호를 입력하면 저장된 계약서 목록이 열립니다.", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("label", {
        class: "scg__label",
        for: "scg-password"
      }, "비밀번호", -1)),
      _withDirectives(_createElementVNode("input", {
        id: "scg-password",
        ref_key: "inputEl",
        ref: inputEl,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
        class: "scg__input",
        type: "password",
        inputmode: "numeric",
        autocomplete: "current-password",
        disabled: busy.value
      }, null, 8, _hoisted_2), [
        [_vModelText, password.value]
      ]),
      (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "submit",
        class: "scg__submit",
        disabled: busy.value || !password.value.trim()
      }, _toDisplayString(busy.value ? '확인 중…' : '들어가기'), 9, _hoisted_4)
    ], 32)
  ]))
}
}

})